import {Component, Inject, Input} from 'ng-metadata/core';
import {PhysicalBestOfferService} from '../../physicalBestOffer/physicalBestOffer.service';

const get= require('lodash/get');

@Component({
    "selector": "prm-brief-result-physical-best-offer",
    templateUrl: 'components/search/fullView/ngrs/ngrsBriefResultLine/briefResultPhysicalBestOffer/briefResultPhysicalBestOffer.html'
})

export class PrmBriefResultPhysicalBestOffer{

    @Input() item:Object;
    private supplyTime:number;
    private loanPeriod:number;

    constructor (private physicalBestOfferService: PhysicalBestOfferService){

        let mmsIdArr = get(this.item,'pnx.control.sourcerecordid');
        if(mmsIdArr){
            let mmsId = mmsIdArr[0];
            this.physicalBestOfferService.getbestOffer(mmsId).then((response)=>this.setbestOffer(response));
        }
    }

    ngOnInit(){
    }

    private setbestOffer(response){
        if(response.supplyTime && response.loanPeriod){
            this.supplyTime = response.supplyTime;
            this.loanPeriod = response.loanPeriod;
        }
    }

    public getSupplyTime(){
        return this.supplyTime;
    }

    public getLoanPeriod(){
        return this.loanPeriod;
    }

    public isOfferFound(){
        return this.supplyTime > 0 && this.loanPeriod > 0;
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrsBriefResultLine/briefResultPhysicalBestOffer/briefResultPhysicalBestOffer.directive.ts